import { BreadcrumbsUI } from "./BreadcrumbsUI";
import { StandardProps } from "../componentMap";

export const Breadcrumbs = ({
  product,
  runtimeConfig,
  configProps,
  flags,
}: Pick<
  StandardProps,
  "product" | "runtimeConfig" | "configProps" | "flags"
>) => {
  const { aliases } = product;
  const beautySimplification = configProps?.beautySimplification === true;

  const { pimProductId: productId } = aliases;

  const { esiBasepath } = runtimeConfig;

  const breadcrumbPath = `${esiBasepath}/esi/breadcrumbs/product/${productId}`;

  const breadcrumbsPosition = flags.breadcrumbsPosition.value;
  if (
    configProps?.breadcrumbsPosition &&
    configProps.breadcrumbsPosition != breadcrumbsPosition &&
    configProps.breadcrumbsPosition != undefined
  ) {
    return (
      breadcrumbsPosition === "two" && <div style={{ height: "44px" }}></div>
    );
  }

  const isBreadcrumbsMatch =
    configProps?.breadcrumbsPosition == breadcrumbsPosition &&
    breadcrumbsPosition === "two";
  return (
    <BreadcrumbsUI
      breadcrumbPath={breadcrumbPath}
      beautySimplification={beautySimplification}
      isBreadcrumbsMatchPositionTwo={isBreadcrumbsMatch}
    />
  );
};
